import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import LoadingImage from "../../assets/image/loading.png";
import "../EmailResponse.css";

function LoadingScreen() {
  return (
    <div className="text-center font-bold mt-[45vh] text-2xl">
      <img className="w-20 mx-auto mb-3" src={LoadingImage} />
      <h1>Loading...</h1>
    </div>
  );
}

function EmailPlatform(props) {
  const [isSuccess, setIsSuccesss] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const query = new URLSearchParams(window.location.search);
  const key = query.get("key");

  const conditionalTemplate = () => {
    
    if (isSuccess === true) {
      return (
        <div className="flex justify-center items-center h-[90vh]">
          <div className="w-[700px]">
            <div className="pb-3 flex justify-between">
              <img src="../../logo-black-teks.png" alt=""/>
            </div>
            <div className="w-full py-10 bg-white px-auto rounded">
              <img className="mx-auto" src="../../verification_succees.svg" alt=""/>
              <div className="text-[28px] neutral-900 font-bold  mt-6 text-center">Email verification success</div>
              <div className="mt-3 px-20 text-sm neutral-700 text-center">Congratulations! you have been successfuly  verified. Go to login page to explore our product.</div>
              <div className="mt-8 mb-12 text-center text-sm"></div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex justify-center items-center h-[90vh]">
          <div className="w-[760px]">
            <div className="pb-3 flex justify-between">
              <img src="../../logo-black-teks.png" alt="" />
            </div>
            <div className="w-full py-20 bg-white px-auto rounded">
              <img className="mx-auto" src="../../verification_expired.svg" alt="" />
              <div className="text-[28px] neutral-900 font-bold  mt-6 text-center">Email verification link expired</div>
              <div className="mt-3 px-20 text-sm neutral-700 text-center">Looks like the verification link has expired.</div>
              {/* <div className="text-sm text-[#585F65] text-center">clicking button below</div> */}
              {/* <div className="mt-8 mb-12 text-center text-sm"></div> */}
            </div>
          </div>
        </div>
      );
    }
  };

  const validateData = async () => {

    const dataSave = {
      EmailKey: key,
    } 

    axios
      .post(
        `${process.env.REACT_APP_API_URL}access/v2/email/validation-platform`,
        dataSave,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        setIsSuccesss(true);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsSuccesss(false);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (key) {
      validateData();
    }
  }, []);

  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div>
          {conditionalTemplate()}
        </div>
      )}
    </>
  );
}

export default withTranslation()(EmailPlatform);
